import { render, staticRenderFns } from "./violationInfo.vue?vue&type=template&id=d5137e5c"
import script from "./violationInfo.vue?vue&type=script&lang=js"
export * from "./violationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports